//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    visible: {
      default: false
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      table: []
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  components: {
    PageMain: () => import('./components/PageMain/index.vue')
  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({}, _.pick(this.initialForm, 'dealerId'))
      this.$axios.get('/mtea/store/admin/dealer/goods', {params: data}).then(res => {
        this.table = res
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit (row) {
      // this.$emit('submit', row)
      // this.$emit('update:visible', false)
      this.handleLoadTableData()
    },
    handleClose () {
      _.extend(this, _.pick(this.$options.data(), 'table'))
      this.$emit('submit')
    },
    handleOpen () {
      this.handleLoadTableData()
    }
  }
}
